module.exports = __webpack_public_path__ + "img/droplet_blue.4f7aad4c.svg";